module.exports = "<div class=\"input-group input-group__money\"> <span class=input-group-label--currency ng-if=\"$ctrl.shouldDecorate('currency')\" ng-bind-html=$ctrl.currency.symbol></span> <input type=text ng-model=$ctrl.value class=input-group-field ng-change=$ctrl.onChange() ng-focus=$ctrl.onFocus() ng-blur=$ctrl.onBlur() ng-disabled=$ctrl.disabled> <span class=input-group-label--percentage ng-if=\"$ctrl.shouldDecorate('percentage')\"> % </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/base/views/money.input.html
// module id = 602
// module chunks = 0